module.exports = __webpack_public_path__ + "img/loding.a5dd04da.gif";